import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on PTO Availabilities
  fetchPtoAvailabilities: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPtoAvailabilities';

    commit(`${mutationPrefix}Pending`);

    return api.fetchPtoAvailabilities(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on PTO Availabilities
  createPtoAvailability: (context, data) => {
    const { commit } = context;
    const mutationPrefix = 'createPtoAvailability';

    commit(`${mutationPrefix}Pending`);

    return api.createPtoAvailability(data)
      .then((response) => {
        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CUSTOM mutations on PTO Availabilities
  updatePtoAvailability: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updatePtoAvailability';

    commit(`${mutationPrefix}Pending`, id);

    return api.updatePtoAvailability(requestParams)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on PTO Availabilities
  deletePtoAvailability: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deletePtoAvailability';

    commit(`${mutationPrefix}Pending`, id);

    return api.deletePtoAvailability(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on PTO Availabilities
  deletePtoAvailabilities: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deletePtoAvailabilities';

    commit(`${mutationPrefix}Pending`);

    return api.deletePtoAvailabilities(args)
      .then((response) => {
        dispatch('delete', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  openFormModal: ({ commit }, payload = null) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ptoAvailability/actions.js